<template>
    <div class="d-block">
        <div class=" mb-4">
            <div class="bg-grid-color">
                <div class=" d-center flex" v-if="season">
                    <img :src="`${season.series.poster}`" width="100" /> <br>
                    <span class="m-1">
                        <h2> {{ season.series.en_title }}</h2>
                        <hr>
                        <h6>{{ season.series.year }}</h6>
                        <h6>Season : {{ season.season_num }}</h6>
                    </span>
                </div>
                <vs-input-number v-model="episode.num" label="Episode:" />
                <ValidationObserver ref="form">
                    <form @submit.prevent="onSubmit">
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="English Name" rules="required" v-slot="{ errors }">
                                    <vs-input class="w-full" label-placeholder="English Name" v-model="episode.en_title" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="Arabic Name" rules="required" v-slot="{ errors }">
                                    <vs-input class="w-full" label-placeholder="Arabic Name" v-model="episode.ar_title" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="IMDB Rating" rules="required" v-slot="{ errors }">
                                    <vs-input class="w-full" v-model="episode.rating" label-placeholder="Imdb Rating" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="Imdb Link" rules=" " v-slot="{ errors }">
                                    <vs-input class="w-full" v-model="episode.imdb" label-placeholder="Imdb Link" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="Trailer" rules="" v-slot="{ errors }">
                                    <vs-input class="w-full" v-model="episode.trailer" label-placeholder="Trailer" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="Year" rules="required" v-slot="{ errors }">
                                    <vs-input class="w-full" label-placeholder="Year" v-model="episode.year" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <vs-input class="w-full" label-placeholder="Arabic tagline" v-model="episode.ar_tagline" />
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <vs-input class="w-full" label-placeholder="English tagline" v-model="episode.en_tagline" />
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="English Plot" rules="required" v-slot="{ errors }">
                                    <vs-textarea label="English Plot" v-model="episode.en_plot" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="Arabic Plot" rules="required" v-slot="{ errors }">
                                    <vs-textarea label="Arabic Plot" v-model="episode.ar_plot" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="vx-row">


                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <vSelect :filterable="true" :multiple="false" v-model="episode.rated"
                                    :options="episode.kind == 1 ? ['G', 'PG', 'PG-13', 'R', 'NC-17'] : ['TV-G', 'TV-PG', 'TV-Y', 'TV-14', 'TV-MA', 'TV-Y7']"
                                    placeholder="Select Rated">

                                </vSelect>
                            </div>
                        </div>
                        <div class="vx-row"> 
                        <vs-button @click="formSubmitted" class="m-3">Save </vs-button>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </div>

    </div>
</template>

<script>
import {
    FormWizard,
    TabContent
} from 'vue-form-wizard'
import StarRating from 'vue-star-rating'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
    props: ['mData'],
    data() {
        return {
            firstName: "",
            imdbInfo: '',
            imdbId: '',
            status: false,
            season: [],
            loading: false,
            episode: {
                status:false,
                id: 0,
                backdrop_path: '',
                comming_soon: false,
                num: 0,
                ar_title: '',
                keywords: '',
                en_title: '',
                ar_tagline: '',
                en_tagline: '',
                ar_plot: '',
                en_plot: '',
                rating: '',
                rated: '',
                duration: '',
                trailer: '',
                imdb: '',
                poster: '',
                release_date: '',
                year: '',
                posterFile: ''
            }
            /// other data....
        }
    },
    created() {
        //this.imdbData();
        this.getInfo()


    },
    mounted() {
        var vm = this;
        if (this.mData && this.mData.length != 0 && this.$store.state.languages.all != null) {
            this.episode.year = this.mData.response.year;
            this.episode.kind = this.mData.response.kind;
            this.episode.id = this.mData.response.id;
            this.episode.ar_title = this.mData.response.ar_title;
            this.episode.en_title = this.mData.response.en_title;
            this.episode.ar_plot = this.mData.response.ar_plot;
            this.episode.en_plot = this.mData.response.en_plot;
            this.episode.trailer = this.mData.response.trailer;
            this.episode.ar_tagline = this.mData.response.ar_tagline;
            this.episode.en_tagline = this.mData.response.en_tagline;
            this.episode.release_date = this.mData.response.released_date;
            this.episode.rating = this.mData.response.rating;
            this.episode.imdb = this.mData.response.imdb;
            this.episode.rated = this.mData.response.rated;
            //this.episode.season = this.mData.response.season;
            this.episode.en_plot = this.mData.response.en_plot;
            this.episode.ar_plot = this.mData.response.ar_plot;
        }
    },
    watch: {
        'episode.num': {
            handler(val) {
                this.sortData()
            },
            deep: true

        }
    },
    methods: {
        getInfo() {
            this.loading = true;
            this.axios.get(`${this.$apiUrl}/v2/seasons/fetch/${this.$route.params.seasonId}`).then(res => {
                this.season = res.data;
                this.episode.num = this.season.last_ep + 1;
                this.sortData();
                this.loading = false;
            })
        },
        sortData() {
            this.episode.en_title = `${this.season.series.en_title} S${this.season.season_num} E${this.episode.num}`;
            this.episode.ar_title = `${this.season.series.ar_title} S${this.season.season_num} E${this.episode.num}`;
            this.episode.rating = this.season.series.rating;
            this.episode.rated = this.season.series.rated;
            this.episode.year = this.season.series.year;
            this.episode.en_tagline = this.season.series.en_tagline;
            this.episode.ar_tagline = this.season.series.ar_tagline;
            this.episode.en_plot = this.season.series.en_plot;
            this.episode.ar_plot = this.season.series.ar_plot;
            this.episode.trailer = this.season.series.trailer;
        },
        onFileChange(e) {
            const file = e.target.files[0];
            this.episode.posterFile = URL.createObjectURL(file);
        },
        validate() {
           
    
            return this.$refs.form.validate().then(result => {
                if (!result) {
                    return false;
                }
                this.formSubmitted();
                if (this.status) {
                    return true;
                } else {
                    return false;
                }
            })
        },
        formSubmitted() {
            var _status = false;
            this.episode.status = false;
            const data = new FormData();
            this.$vs.loading()
            data.append('id', this.episode.id);
            data.append('comming_soon', this.episode.comming_soon);
            data.append('ar_title', this.episode.ar_title);
            data.append('season', this.season.id);
            data.append('en_title', this.episode.en_title);
            data.append('ar_tagline', this.episode.ar_tagline);
            data.append('en_tagline', this.episode.en_tagline);
            data.append('ar_plot', this.episode.ar_plot);
            data.append('en_plot', this.episode.en_plot);
            data.append('rating', this.episode.rating);
            data.append('rated', this.episode.rated);
            data.append('duration', this.episode.duration);
            data.append('trailer', this.episode.trailer);
            data.append('imdb', this.episode.imdb);
            data.append('poster', this.episode.poster);
            data.append('release_date', this.episode.release_date);
            data.append('year', this.episode.year);
            data.append('num', this.episode.num);
            data.append('posterFile', this.episode.posterFile);
            this.axios.post(`${this.$apiUrl}/v2/seasons/episodes`, data).then(res => {
                this.$vs.loading.close()
                this.$emit('success', res.data)
                if (this.episode.id == 0) {
                    this.$vs.notify({
                        color: 'success',
                        title: 'episode Addedd',
                        text: '',
                        position: 'bottom-center'
                    })
                } else {
                    this.$vs.notify({
                        color: 'primary',
                        title: 'episode Updated',
                        text: '',
                        position: 'bottom-center'
                    })
                }
                this.$router.push({ name: 'editEpisode', params: { id: res.data.id } })
                this.episode.id = res.data.response.id;
                this.episode.status = true;
                

            }).catch(errors => {
                this.episode.status = false;
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'danger',
                    title: 'episode was not Addedd',
                    text: ''
                })
            });
            return _status;
        },
    },
    components: {
        FormWizard,
        TabContent,
        vSelect, StarRating
    }
}
</script>
<style lang="scss">
.vs-input {
    width: 90%;
    margin-top: 10px;
}
</style>